export enum QuakerCornerTrimDetailType {
  Y = 'y',
  StopBeforeAngle = 'stop-before-angle',
  // Default = undefined,
}
